import { render } from "./index.vue?vue&type=template&id=3f9c83ee&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=3f9c83ee&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=3f9c83ee&lang=scss"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9c83ee"]])

export default __exports__